import { observable } from "mobx"

class Product {
    @observable status

    constructor({
        emailLimit,
        name,
        productId,
        productType,
        status,
    }) {
        this.emailLimit = emailLimit
        this.name = name.replace(/&amp;/gi, '&')
        this.productId = productId
        this.productType = productType
        this.status = status
    }

    toJSON() {
        return {
            emailLimit: this.emailLimit,
            name: this.name,
            productId: this.productId,
            productType: this.productType,
            status: this.status,
        }
    }
}

export default Product
